// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-toggle="nav-mobile"], #mobile_close').on('click', (event) => {
  event.preventDefault();
  $('[data-toggle="nav-mobile"]').toggleClass('hamburger--active');
  $('.mobile-nav').toggleClass('mobile-nav--visible');
  $('.mobile-nav').scrollTop(0);
  $('body').toggleClass('nav-mobile-is-visible');
  $('html').toggleClass('nav-mobile-is-visible');
});

// close mobile nav when clicking outside
$(document).on('click', function (event) {
  let $mobileNav = $('.mobile-nav');

  if (
    $mobileNav.hasClass('mobile-nav--visible') &&
    !$(event.target).closest('.mobile-nav').length &&
    !$(event.target).closest('[data-toggle="nav-mobile"]').length && // Exclude the toggle button from being considered as "outside"
    !$(event.target).closest('#mobile_close').length // Exclude the close button from being considered as "outside"
  ) {
    $('[data-toggle="nav-mobile"]').removeClass('hamburger--active');
    $mobileNav.removeClass('mobile-nav--visible');
    $('body').removeClass('nav-mobile-is-visible');
    $('html').removeClass('nav-mobile-is-visible');
  }
});

// toggle nest menu to swipe to new menu
$('.mobile-nav .caret').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  const $topMenu = $('.mobile-top-menu');

  if ($topMenu.hasClass('swipe-left')) {
    $topMenu.addClass('further');
    $this.siblings('.sub-menu').addClass('menu-visible');
  } else {
    $topMenu.addClass('swipe-left');
    $this.siblings('.sub-menu').addClass('menu-visible');
  }
});

// toggle to swipe back to main menu
$('.mobile-nav .mobile-nav-back').on('click', (event) => {
  event.preventDefault();
  const $topMenu = $('.mobile-top-menu');

  if ($topMenu.hasClass('further')) {
    $('.mobile-top-menu').removeClass('further');
    $('.sub-menu .sub-menu').removeClass('menu-visible');
  } else {
    $('.mobile-top-menu').removeClass('swipe-left');
    $('.sub-menu').removeClass('menu-visible');
    $('.help-menu').removeClass('menu-visible');
  }
});

// help menu toggle
$('#help_toggle').on('click', (event) => {
  event.preventDefault();
  $('.mobile-top-menu').addClass('swipe-left');
  $('.help-menu').addClass('menu-visible');
});
